module.exports = __webpack_public_path__ + "img/_logo-usps.fde3b51c.svg";